var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcosostenibilita(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.84,
    height: 34.619,
    viewBox: "0 0 15.568 9.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9bbe1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277775
    },
    d: "M114.198 157.48h-7.848v-1.588h7.848z",
    transform: "translate(-105.29 -149.306)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h.987a.27.27 0 0 0 .271-.27v-.16a.28.28 0 0 0-.071-.184C.614-1.252-.025-1.571-.73-1.571c-.321 0-.619.066-.893.198a2.19 2.19 0 0 0-.711.54 2.576 2.576 0 0 0-.471.807 2.893 2.893 0 0 0-.171 1c0 .341.052.666.156.972.103.307.249.577.438.813.189.235.417.42.684.555.267.136.561.204.882.204.406 0 .782-.1 1.128-.299.267-.156.489-.364.666-.624a.265.265 0 0 1 .38-.066l.67.494c.11.081.147.234.076.35a2.924 2.924 0 0 1-1.033 1c-.509.299-1.121.449-1.834.449a3.52 3.52 0 0 1-1.465-.304 3.75 3.75 0 0 1-1.169-.824 3.824 3.824 0 0 1-.781-1.208 3.83 3.83 0 0 1-.283-1.47c0-.549.094-1.06.283-1.535.189-.473.446-.884.77-1.234s.705-.624 1.143-.823a3.368 3.368 0 0 1 1.407-.299c.626 0 1.191.183 1.697.549.174.126.419-.01.419-.226a.27.27 0 0 1 .27-.27h.678c.149 0 .271.121.271.27V.81c0 .149-.122.27-.271.27H0A.271.271 0 0 1-.271.81V.271C-.271.121-.149 0 0 0",
    transform: "matrix(.35278 0 0 -.35278 5.583 2.687)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.149 0-.305-.03-.465-.091A1.966 1.966 0 0 1-.94-.353a2.748 2.748 0 0 1-.439-.4 2.499 2.499 0 0 1-.352-.518v.926c0 .15-.122.271-.271.271h-.774a.27.27 0 0 1-.271-.271v-5.061a.27.27 0 0 1 .271-.271h.892a.27.27 0 0 1 .27.271v3.051c0 .044.01.089.03.129.152.29.388.51.708.661.273.128.576.207.909.237a.273.273 0 0 1 .256.269v1.048A.513.513 0 0 1 .177 0Z",
    transform: "matrix(.35278 0 0 -.35278 7.927 1.68)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.272.272 0 0 0-.26.351 1.465 1.465 0 0 0 .398.654 1.417 1.417 0 0 0 .983.385A1.42 1.42 0 0 0 2.526.338.27.27 0 0 0 2.263 0Zm3.286 1.562a2.806 2.806 0 0 1-.919.629c-.36.158-.768.236-1.224.236-.456 0-.868-.078-1.235-.236a2.79 2.79 0 0 1-.935-.635 2.754 2.754 0 0 1-.588-.931 3.108 3.108 0 0 1-.203-1.127c0-.385.069-.752.208-1.102.139-.349.337-.655.593-.918.257-.264.567-.473.93-.626.364-.154.771-.23 1.219-.23.627 0 1.167.137 1.62.411.334.203.601.447.801.734a.272.272 0 0 1-.153.415l-.682.189a.262.262 0 0 1-.292-.106 1.18 1.18 0 0 0-.433-.387 1.65 1.65 0 0 0-.807-.208c-.186 0-.364.032-.535.096a1.452 1.452 0 0 0-.883.95.272.272 0 0 0 .258.354h4.003c.014.057.024.128.027.214.004.085.006.174.006.267 0 .378-.067.741-.199 1.091a2.709 2.709 0 0 1-.577.92",
    transform: "matrix(.35278 0 0 -.35278 8.73 2.529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.272.272 0 0 0-.26.351c.022.075.05.147.083.215a1.43 1.43 0 0 0 .759.722c.167.068.348.102.54.102A1.419 1.419 0 0 0 2.527.338.272.272 0 0 0 2.263 0Zm3.286 1.562a2.806 2.806 0 0 1-.919.629c-.36.158-.768.236-1.223.236-.457 0-.869-.078-1.236-.236a2.79 2.79 0 0 1-.935-.635 2.77 2.77 0 0 1-.588-.931 3.13 3.13 0 0 1-.203-1.127c0-.385.069-.752.209-1.102.138-.349.337-.655.592-.918.257-.264.567-.473.931-.626.363-.154.77-.23 1.219-.23.627 0 1.167.137 1.619.411.334.203.601.447.801.734a.272.272 0 0 1-.153.415l-.682.189a.262.262 0 0 1-.292-.106 1.18 1.18 0 0 0-.433-.387 1.65 1.65 0 0 0-.807-.208c-.185 0-.364.032-.535.096a1.452 1.452 0 0 0-.883.95.272.272 0 0 0 .258.354h4.003c.015.057.024.128.028.214.003.085.005.174.005.267 0 .378-.067.741-.199 1.091a2.709 2.709 0 0 1-.577.92",
    transform: "matrix(.35278 0 0 -.35278 10.99 2.529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a1.4 1.4 0 0 1-.514.502c-.22.129-.506.192-.855.192-.491 0-.934-.099-1.325-.298A2.348 2.348 0 0 1-3.15.093a.268.268 0 0 0-.443.206v.029a.27.27 0 0 1-.269.271h-.754a.27.27 0 0 1-.27-.271v-5.061a.27.27 0 0 1 .27-.271h.892a.27.27 0 0 1 .271.271v2.954a.29.29 0 0 0 .014.092c.049.154.124.295.22.425.108.143.227.266.359.369.131.103.272.183.422.241.15.056.295.086.438.086a.774.774 0 0 0 .652-.311c.158-.207.236-.534.236-.983v-2.873a.27.27 0 0 1 .27-.271H.05a.27.27 0 0 1 .27.271v3.225c0 .271-.023.538-.069.802C.204-.442.121-.207 0 0",
    transform: "matrix(.35278 0 0 -.35278 14.455 1.918)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9bbe1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.89.89 0 0 1-.619-.238.805.805 0 0 1-.269-.609c0-.235.092-.44.275-.609a.88.88 0 0 1 .616-.248c.228 0 .431.077.601.23a.768.768 0 0 1 .266.579c0 .274-.093.496-.277.659A.88.88 0 0 1 0 0",
    transform: "matrix(.35278 0 0 -.35278 2.361 4.423)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v3.686a.27.27 0 0 1-.271.27h-.891a.27.27 0 0 1-.271-.27V.549c0-.044-.01-.09-.031-.13a1.768 1.768 0 0 0-.604-.702 1.48 1.48 0 0 0-.808-.251c-.62 0-.93.431-.93 1.294v2.926a.27.27 0 0 1-.27.27h-.893a.27.27 0 0 1-.269-.27V.449c0-.726.149-1.275.449-1.646.299-.37.737-.556 1.314-.556.471 0 .902.097 1.294.289.392.193.712.481.962.866l.032-.449a.7.7 0 0 1 .284-.487c.16-.117.368-.176.625-.176a2.89 2.89 0 0 1 .62.064v.988c0 .109-.055.221-.156.262A.263.263 0 0 0 .08-.32C.026-.256 0-.149 0 0",
    transform: "matrix(.35278 0 0 -.35278 5.917 5.453)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h.892a.27.27 0 0 1 .269.27v5.061a.27.27 0 0 1-.269.271H0a.272.272 0 0 1-.271-.271V.27C-.271.121-.149 0 0 0",
    transform: "matrix(.35278 0 0 -.35278 6.514 6.034)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 2.668 3.201c.04.049.062.111.062.174v.508a.27.27 0 0 1-.27.27H-1.5a.271.271 0 0 1-.271-.27v-.464c0-.149.122-.271.271-.271H.644a.27.27 0 0 0 .207-.444L-1.835-.497a.27.27 0 0 1-.063-.174v-.508a.27.27 0 0 1 .27-.269h4.142a.27.27 0 0 1 .27.269v.465a.27.27 0 0 1-.27.271H.207A.27.27 0 0 0 0 0",
    transform: "matrix(.35278 0 0 -.35278 7.918 5.523)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9bbe1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.539.451-1.19.681-1.936.681-.72 0-1.31-.224-1.752-.666a2.184 2.184 0 0 1-.664-1.587c0-.541.132-.97.392-1.274.269-.315.59-.475.954-.475.247 0 .466.058.651.175a.656.656 0 0 1 .327.574c0 .114-.04.28-.234.422-.196.144-.401.187-.61.113-.025-.009-.126-.053-.232.118a.814.814 0 0 0-.109.437c0 .33.111.591.339.801.233.215.553.32.975.32a.926.926 0 0 0 .772-.375c.21-.269.313-.565.313-.906 0-.294-.061-.589-.179-.88-.118-.289-.408-.654-.863-1.085-.493-.462-.814-.844-.982-1.166a2.13 2.13 0 0 1-.257-.982c0-.428.045-.574.083-.653.078-.16.229-.249.424-.249.159 0 .53.073.53.753 0 .178.069.385.204.614.141.239.414.519.809.833.423.333.754.614.985.834a3.3 3.3 0 0 1 .623.816c.177.324.266.682.266 1.068C.829-1.048.55-.463 0 0",
    transform: "matrix(.35278 0 0 -.35278 3.26 1.896)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v2.488h1.006v-.23h-.75v-.882h.64v-.228h-.64V.231h.761V0Z",
    transform: "matrix(.35278 0 0 -.35278 1.363 7.84)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c0-.363-.207-.526-.583-.526h-.008c-.377 0-.583.16-.583.526v1.493c0 .349.206.527.583.527h.008c.376 0 .583-.178.583-.527V1.06h-.257v.369c0 .256-.096.359-.33.359s-.331-.103-.331-.359V.063c0-.255.097-.358.331-.358s.33.103.33.358v.431H0Z",
    transform: "matrix(.35278 0 0 -.35278 2.255 7.665)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c.238 0 .341.099.341.358v1.366c0 .259-.103.359-.341.359-.238 0-.342-.1-.342-.359V.358C-.342.099-.238 0 0 0m-.015 2.314h.029c.377 0 .583-.17.583-.526V.295c0-.356-.206-.526-.583-.526h-.029c-.377 0-.583.17-.583.526v1.493c0 .358.206.526.583.526",
    transform: "matrix(.35278 0 0 -.35278 2.607 7.77)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v.327c0 .238-.097.342-.32.342-.224 0-.321-.104-.321-.342V.153c0-.167.057-.216.225-.309l.355-.196C.131-.459.259-.59.259-.8v-.331c0-.362-.196-.518-.572-.518H-.32c-.377 0-.573.152-.573.518v.413h.252v-.355c0-.236.097-.349.325-.349.227 0 .323.113.323.349v.199c0 .167-.065.23-.235.326l-.348.193c-.217.121-.317.223-.317.44v.299c0 .348.228.512.569.512h.008c.34 0 .568-.164.568-.512V0Z",
    transform: "matrix(.35278 0 0 -.35278 3.266 7.269)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c.238 0 .341.099.341.358v1.366c0 .259-.103.359-.341.359-.238 0-.342-.1-.342-.359V.358C-.342.099-.238 0 0 0m-.015 2.314h.029c.377 0 .583-.17.583-.526V.295c0-.356-.206-.526-.583-.526h-.029c-.377 0-.583.17-.583.526v1.493c0 .358.206.526.583.526",
    transform: "matrix(.35278 0 0 -.35278 3.7 7.77)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v.327c0 .238-.097.342-.32.342-.224 0-.321-.104-.321-.342V.153c0-.167.057-.216.225-.309l.355-.196C.131-.459.259-.59.259-.8v-.331c0-.362-.196-.518-.572-.518H-.32c-.377 0-.573.152-.573.518v.413h.252v-.355c0-.236.097-.349.325-.349.227 0 .323.113.323.349v.199c0 .167-.065.23-.235.326l-.348.193c-.217.121-.317.223-.317.44v.299c0 .348.228.512.569.512h.008c.34 0 .568-.164.568-.512V0Z",
    transform: "matrix(.35278 0 0 -.35278 4.36 7.269)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-.455v-2.258h-.256V0h-.452v.23H0Z",
    transform: "matrix(.35278 0 0 -.35278 4.936 7.044)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v2.488h1.006v-.23h-.75v-.882h.64v-.228h-.64V.231h.761V0Z",
    transform: "matrix(.35278 0 0 -.35278 5.033 7.84)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v2.488h.259L.988.601v1.887h.239V0H.981L.238 1.924V0Z",
    transform: "matrix(.35278 0 0 -.35278 5.518 7.84)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277775
    },
    d: "M111.402 156.269h.09v.877h-.09z",
    transform: "translate(-105.29 -149.306)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-.359v-.945H0c.22 0 .306.106.306.32v.373C.306-.078.198 0 0 0m-.359.228h.344c.2 0 .306.079.306.252v.289c0 .212-.085.319-.306.319h-.344ZM.27.121C.501.086.562-.103.562-.273v-.41c0-.291-.2-.49-.577-.49h-.6v2.488h.607c.377 0 .555-.198.555-.49V.513C.547.346.486.143.27.121",
    transform: "matrix(.35278 0 0 -.35278 6.58 7.427)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277775
    },
    d: "M112.211 156.269h.09v.877h-.09z",
    transform: "translate(-105.29 -149.306)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-.963v2.488h.256V.234H0Z",
    transform: "matrix(.35278 0 0 -.35278 7.512 7.84)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277775
    },
    d: "M112.908 156.269h.09v.877h-.09z",
    transform: "translate(-105.29 -149.306)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h-.455v-2.258h-.256V0h-.452v.23H0Z",
    transform: "matrix(.35278 0 0 -.35278 8.22 7.044)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0-.259 1.294L-.519 0Zm-.327 1.846-.362.458h.316l.245-.458zm.37-2.07h-.605l-.124-.615h-.249l.527 2.488h.305L.431-.839H.167Z",
    transform: "matrix(.35278 0 0 -.35278 8.535 7.545)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a3.75 3.75 0 0 1-1.12 2.478 4.058 4.058 0 0 1-.709.563c-.059-.048-.115-.094-.178-.143-.452-.357-.62-.582-.68-.684a1.169 1.169 0 0 1-.111-.237c.248-.12.481-.274.687-.481A2.4 2.4 0 0 0-1.396-.03a2.406 2.406 0 0 0-.291-1.382l-.419.418a.275.275 0 0 1-.388 0l-.603-.603a.273.273 0 0 1 0-.387l.417-.418a2.367 2.367 0 0 0-1.382-.284 2.35 2.35 0 0 0-1.524.705 2.406 2.406 0 0 0-.716 1.744c0 .675.24 1.259.714 1.733.207.207.432.358.671.477l-.002.047c0 .409.107.822.317 1.226.055.105.122.213.2.325a3.697 3.697 0 0 1-2.166-1.084A3.729 3.729 0 0 1-7.699-.235c-.01-1.055.367-1.972 1.121-2.726.692-.693 1.526-1.07 2.478-1.121a3.737 3.737 0 0 1 2.246.55.273.273 0 0 0 .338-.034l.391-.391a.275.275 0 0 1 .389.002l.593.601a.273.273 0 0 1-.001.387l-.379.38a.274.274 0 0 0-.034.34C-.143-1.584.045-.831 0 0",
    transform: "matrix(.35278 0 0 -.35278 3.716 4.638)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9bbe1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0s3.506 3.406 3.364 4.586c-.142 1.182-1.476 1.127-2.012 1.881C.615 7.505.705 8.475.81 9.608c.05.543-.056 1.009-.056 1.009s.401-.4.911-.629c.376-.169 2.228-.796 2.286-2.49.059-1.694-.259-3.629.218-3.097.477.534.185 1.411.676 2.298.396.716.982 1.501 2.509 1.549.807.025.992.193.992.193S8.065 7.791 7.942 7c-.089-.581-.123-1.434-1.105-2.04-.715-.441-1.797-.179-2.479-.866-.681-.687.259-.426.259-.426s1.025.518 1.882.093c.858-.424 1.033-1.28 1.033-1.28s-1.142-1.014-1.88-.778c-.737.237-1.359 1.655-1.854 1.43-.495-.224-1.314-1.101-1.637-1.581-.323-.481-1.049-1.769-.96-2.453.089-.684-.602-.532-.602-.532l-1.253.287z",
    transform: "matrix(.35278 0 0 -.35278 10.465 7.61)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcosostenibilita);
export default __webpack_public_path__ + "static/media/ecosostenibilita.0f9c0a9a79ba7e5bb0ea0bc96ac35b9a.svg";
export { ForwardRef as ReactComponent };